<template>
  <v-row>
    <v-col cols="12">
      <span class="green--text" style="font-size: 18px">{{ serie.nome }}</span>
    </v-col>
    <v-col cols="4">
      <v-card width="400">
        <v-img height="200" :src="serie_img_src">
          <v-row class="ma-6" justify="end" align="center">
            <v-btn icon color="grey" @click="$refs.input_info.click()"
              ><v-icon>mdi-camera</v-icon></v-btn
            >
          </v-row>
          <input
            type="file"
            style="display: none"
            @change="onFileInfoChange($event)"
            ref="input_info"
          />
        </v-img>
      </v-card>
    </v-col>
    <v-col cols="8">
      <v-card width="200">
        <v-img height="200" :src="serie_img_brand_src">
          <v-row class="ma-6" justify="end" align="center">
            <v-btn icon color="grey" @click="$refs.input_brand.click()"
              ><v-icon>mdi-camera</v-icon></v-btn
            >
          </v-row>
          <input
            type="file"
            style="display: none"
            @change="onFileBrandChange($event)"
            ref="input_brand"
          />
        </v-img>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-textarea
        rows="5"
        v-model="info_serie"
        outlined
        label="Informazioni Serie"
      />
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    id_specie: String,
    serie: Object,
  },
  created() {
    this.debounce_info_serie = _.debounce(this.send_info_serie, 2000);
  },
  data() {
    return {
      info_serie: "",
      img_serie_md5: null,
      img_serie_brand_md5: null,
      file_info: null,
      file_brand: null,
      disable_watch: true,
    };
  },
  mounted() {
    this.disable_watch = true;
    this.$store
      .dispatch("fetch_info_serie_by_id", {
        id_specie: this.id_specie,
        id_serie: this.serie.id,
      })
      .then((res) => {
        this.info_serie = res.info_serie;
        this.img_serie_md5 = res.img_serie_info_md5;
        this.img_serie_brand_md5 = res.img_serie_brand_md5;
        setTimeout(() => {
          this.disable_watch = false;
        }, 2000);
      });
  },
  watch: {
    info_serie: function () {
      if (this.disable_watch) {
        return;
      }
      this.debounce_info_serie();
    },
  },
  computed: {
    serie_img_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/serie/" +
        this.serie.id +
        "/info_img?md5=" +
        this.img_serie_md5
      );
    },
    serie_img_brand_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/serie/" +
        this.serie.id +
        "/brand_img_serie?md5=" +
        this.img_serie_brand_md5
      );
    },
  },
  methods: {
    send_info_serie() {
      this.$store.dispatch("send_serie_info", {
        id_specie: this.id_specie,
        id_serie: this.serie.id,
        info: this.info_serie,
      });
    },
    onFileBrandChange(e) {
      this.file_brand = e.target.files[0];
      this.invia_img_brand();
    },
    onFileInfoChange(e) {
      this.file_info = e.target.files[0];
      this.invia_info_img();
    },
    invia_info_img() {
      let formData = new FormData();
      formData.append("file", this.file_info);
      this.$store
        .dispatch("send_serie_info_img", {
          id_specie: this.id_specie,
          id_serie: this.serie.id,
          formData: formData,
        })
        .then((res) => {
          this.img_serie_md5 = res.data.md5;
        })
        .finally(() => {
          this.file_info = null;
        });
    },
    invia_img_brand() {
      let formData = new FormData();
      formData.append("file", this.file_brand);
      this.$store
        .dispatch("send_serie_brand_img", {
          id_specie: this.id_specie,
          id_serie: this.serie.id,
          formData: formData,
        })
        .then((res) => {
          this.img_serie_brand_md5 = res.data.md5;
        })
        .finally(() => {
          this.file_brand = null;
        });
    },
  },
};
</script>